/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AnonymousFhirIdLinkGet$Params {
  fhirId: string;
}

export function anonymousFhirIdLinkGet(http: HttpClient, rootUrl: string, params: AnonymousFhirIdLinkGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, anonymousFhirIdLinkGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<string>;
    })
  );
}

anonymousFhirIdLinkGet.PATH = '/Anonymous/{fhirId}/link';
